// assets
import { IconEqual, IconEqualNot, IconBusinessplan } from '@tabler/icons';
import ScaleIcon from '@mui/icons-material/Scale';
import ListIcon from '@mui/icons-material/List';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import StorefrontIcon from '@mui/icons-material/Storefront';

// constant
const icons = {
    IconEqual,
    IconBusinessplan,
    IconEqualNot,
    ScaleIcon,
    ListIcon,
    CompareArrowsIcon,
    StorefrontIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const opciones = {
    id: 'opciones',
    title: 'Opciones',
    type: 'group',
    children: [
        {
            id: 'ArcorTT',
            title: 'Tradicional',
            type: 'collapse',
            icon: icons.CompareArrowsIcon,
            children: [
                {
                    id: 'homologados',
                    title: 'Homologados',
                    type: 'item',
                    url: '/homologaciones/homologados',
                    target: false,
                    icon: icons.ListIcon
                },
                {
                    id: 'nohomologados',
                    title: 'No homologados',
                    type: 'item',
                    url: '/homologaciones/no-homologados',
                    target: false,
                    icon: icons.IconEqualNot
                },
                {
                    id: 'productos',
                    title: 'Maestro Productos',
                    type: 'item',
                    url: '/maestros/productos',
                    target: false,
                    icon: icons.StorefrontIcon
                }
            ]
        },
        {
            id: 'ArcorMT',
            title: 'Moderno',
            type: 'collapse',
            icon: icons.CompareArrowsIcon,
            children: [
                {
                    id: 'homologadosmt',
                    title: 'Homologados',
                    type: 'item',
                    url: '/homologaciones/homologadosmt',
                    target: false,
                    icon: icons.ListIcon
                },
                {
                    id: 'nohomologadosmt',
                    title: 'No homologados',
                    type: 'item',
                    url: '/homologaciones/no-homologadosmt',
                    target: false,
                    icon: icons.IconEqualNot
                },
                {
                    id: 'localesmt',
                    title: 'Locales',
                    type: 'item',
                    url: '/maestros/localesmt',
                    target: false,
                    icon: icons.ListIcon
                },
                {
                    id: 'localesmtsinhomologar',
                    title: 'Locales sin homologar',
                    type: 'item',
                    url: '/maestros/localesmtnohomologados',
                    target: false,
                    icon: icons.IconEqualNot
                },
                {
                    id: 'productosmt',
                    title: 'Maestro Productos',
                    type: 'item',
                    url: '/maestros/productosmt',
                    target: false,
                    icon: icons.StorefrontIcon
                }
            ]
        },
        
    ]
};


export default opciones;
